import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const userListItem = style({
  display: 'flex',
  gap: space.s8,
  alignItems: 'center',
  padding: `${space.s10}px ${space.s16}px`,
  cursor: 'pointer',
});
